import { ChangeDetectionStrategy, Component, type OnInit } from '@angular/core';
import { ButtonModule } from '@fino-ui/button';
import { BaseModalComponent } from '@fino-ui/modal';
import { TranslationModule } from '@fino-ui/translation';

@Component({
  selector: 'app-kws-deactivate',
  templateUrl: './deactivate.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslationModule, ButtonModule],
})
export class KWSDeActivateComponent
  extends BaseModalComponent<{}, boolean>
  implements OnInit
{
  constructor() {
    super();
    Object.assign(this, this.data ?? {});
  }

  ngOnInit(): void {}

  abort() {
    this.close();
  }

  submit() {
    this.result = true;
    this.close();
  }
}
